import { render, staticRenderFns } from "./SlideGroupResolveModal.vue?vue&type=template&id=2aa25253&scoped=true"
import script from "./SlideGroupResolveModal.vue?vue&type=script&lang=js"
export * from "./SlideGroupResolveModal.vue?vue&type=script&lang=js"
import style0 from "./SlideGroupResolveModal.vue?vue&type=style&index=0&id=2aa25253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa25253",
  null
  
)

export default component.exports